import { ApiResponse, RedeemCodeResponse, ReferralCode, ReferralStatus } from '@arrived/models';

import { api } from './api';
import { unwrapApiResponse } from './utils';

export const getReferralCode = async () => {
  const response = await api.get<ApiResponse<ReferralCode>>('/referral/get-referral-code');

  return unwrapApiResponse(response.data);
};

export const postRefereeSignup = async (referralCode: ReferralCode) => {
  const response = await api.post<ApiResponse<boolean>>(`/referral/referee-signup/${referralCode}`);

  return unwrapApiResponse(response.data);
};

export const postRedeemCode = async (referralCode: ReferralCode) => {
  const response = await api.post<ApiResponse<RedeemCodeResponse>>(`/referral/redeem-code/${referralCode}`);

  return unwrapApiResponse(response.data);
};

export const getReferralStatuses = async () => {
  const response = await api.get<ApiResponse<ReferralStatus[]>>('/referral/get-my-referral-statuses');

  return unwrapApiResponse(response.data);
};
